import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { ROUTES } from "../../../routing/routes";
import { NavLink } from "react-router-dom";
import _environment from "../../../_environment/_environment";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
}

const Footer = ({ ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[Footer] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[Footer] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <footer className="meeters footer">
      <div className="main">
        <div className="container">
          <div className="logos">
            {_environment.assets.footerLogos.map((img: string, i) => (
              <img key={i} src={img} alt="Meeters"/>
            ))}
          </div>
          <div className="menu">
            <p className="font-weight-bold">Forminprogress S.r.l.</p>
            <p className="mb-0">Via della Fiera, 11</p>
            <p className="mb-0">44124 Ferrara - Italy</p>
            <p className="mb-0">P.IVA 01926130384</p>
          </div>
          <div className="menu">
            <p className="font-weight-bold">
              Contacts
            </p>
            <a
              href={`tel:${_environment.whatsapp.number}`}
              rel="noopener noreferrer"
              className="mb-0 whatsapp"
            >
              {_environment.whatsapp.formatted}
            </a>
          </div>
          <div className="menu">
            <p>
              <strong>Useful links</strong>
            </p>
            <a
              href={_environment.meetersURL}
              target="_blank"
              rel="noopener noreferrer"
              title={t("footer.links.aboutMeeters")}
            >
              {t("footer.links.aboutMeeters")}
            </a>
            {/* <NavLink to={ROUTES.FAQ} exact={true}>
              {t("footer.links.faq")}
            </NavLink> */}
            <NavLink to={ROUTES.TUTORIALS} exact={true}>
              {t("footer.links.tutorials")}
            </NavLink>
            <NavLink to={ROUTES.FAQ} exact={true}>
              {t("footer.links.faq")}
            </NavLink>
            <NavLink to={ROUTES.PRIVACY_POLICY} exact={true}>
              {t("footer.links.privacyPolicy")}
            </NavLink>

            <NavLink to={ROUTES.COOKIE_POLICY} exact={true}>
              {t("footer.links.cookiePolicy")}
            </NavLink>

            <NavLink to={ROUTES.TERMS_OF_SERVICE} exact={true}>
              {t("footer.links.termsOfService")}
            </NavLink>
          </div>
          {/* <div className="menu">
                        <a href="#" target="_blank">
                            Facebook
                        </a>
                        <a href="#" target="_blank">
                            Instagram
                        </a>
                        <a href="#" target="_blank">
                            LinkedIn
                        </a>
                        <a href="#" target="_blank">
                            Youtube
                        </a>
                    </div> */}
        </div>
      </div>
      <div className="copy">
        <div className="container">
          <span>
            {`© ${moment().format("YYYY")} Remtech made with `}
            <a target="_blank" rel="noopener noreferrer" href={_environment.meetersURL}>
              <strong>Meeters</strong>
            </a>
            &nbsp;by
            <a target="_blank" rel="noopener noreferrer" href="//botika.ai">
              <img
                src="/assets/images/logos/logo-botika.png"
                className={"logo-meeters"}
                alt="Meeters"
              />
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
